import React, { useEffect, useState } from "react";

const KF = `
@keyframes fvLetter { from {opacity:0; transform:translateY(22px)} to {opacity:1; transform:none} }
@keyframes fvFade { from {opacity:0} to {opacity:1} }
@keyframes fvOut { to {opacity:0; visibility:hidden} }
`;

export const FirstVisitWelcome = () => {
  const [show, setShow] = useState(false);
  useEffect(() => {
    if (!localStorage.getItem("mk_visited")) {
      localStorage.setItem("mk_visited", "1");
      setShow(true);
      const t = setTimeout(() => setShow(false), 3000);
      return () => clearTimeout(t);
    }
  }, []);
  if (!show) return null;
  return (
    <div className="fixed inset-0 z-[200] bg-[#0A0A0A] flex flex-col items-center justify-center cursor-pointer" onClick={() => setShow(false)} style={{ animation: "fvOut 0.6s ease 2.4s forwards" }} data-testid="first-visit-welcome">
      <style>{KF}</style>
      <div className="flex">
        {"MRQK UK".split("").map((c, i) => (
          <span key={i} className="font-heading text-white text-5xl md:text-6xl font-light tracking-[0.15em]" style={{ opacity: 0, animation: `fvLetter 0.6s cubic-bezier(0.22,1,0.36,1) ${i * 60 + 100}ms forwards` }}>{c === " " ? "\u00A0" : c}</span>
        ))}
      </div>
      <p className="text-neutral-400 text-[11px] tracking-[0.4em] uppercase mt-5" style={{ opacity: 0, animation: "fvFade 0.8s ease 900ms forwards" }}>Welcome to the UK's curated marketplace</p>
    </div>
  );
};
